
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { UsuarioMdc } from '../interfaces/beans.interface';

@Injectable({
  providedIn: 'root'
})
export class UsuarioMDCService {

  url = environment.url + '/usuarios-mdcs';

  constructor(private http: HttpClient) {}

  getAll(username: string) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.get(`${ this.url }/all?usuario=${ username }&cliente=${ localStorage.getItem('idCliente') }`, { headers }).pipe( map( data => data));
  }

  add(usuariosMdc: UsuarioMdc[]) {
    let body = JSON.stringify(usuariosMdc);
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.post(`${ this.url }/add?usuario=${ localStorage.getItem('idUsuario')}`, body, { headers }).pipe( map( data => data));
  }

  delete(usuario: string, mdc: string, rol: string) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.delete(`${ this.url }/delete?usuario=${ usuario }&mdc=${ mdc }&cliente=${ localStorage.getItem('idCliente') }&rol=${ rol }&idUsuario=${ localStorage.getItem('idUsuario') }`, { headers }).pipe( map( data => data));
  }
}
